import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING || '',
    enableAutoRouteTracking: true,
  },
});

appInsights.loadAppInsights();
appInsights.trackPageView();

export const setAuthenticatedUserContext = (userId: string, userEmail?: string) => {
  appInsights.setAuthenticatedUserContext(userId, userEmail, true);
};

export default appInsights;